export default "__VITE_ASSET__b4219073__"